import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import TemplateContainer from "../../common/TemplateContainer";
import BrandPersonaSelector from "./BrandPersonaSelector";
import BrandToneSelector from "./BrandToneSelector";
import BrandVoiceSelector from "./BrandVoiceSelector";
import CustomBrandPersonaVoiceToneInput from "./CustomBrandPersonaVoiceToneInput";
import CustomBrandPersonaVoiceToneToggle from "./CustomBrandPersonaVoiceToneToggle";

const BrandSettings = () => {
  const { values } = useFormikContext<Partial<Template>>();
  const useCustom = Boolean(values?.useCustomBrandPersonaVoiceTone);

  return (
    <div className="space-y-6 animate-fadeIn">
      <TemplateContainer>
        <CustomBrandPersonaVoiceToneToggle />
        {useCustom ? (
          <CustomBrandPersonaVoiceToneInput />
        ) : (
          <>
            <BrandPersonaSelector />
            <BrandVoiceSelector />
            <BrandToneSelector />
          </>
        )}
      </TemplateContainer>
    </div>
  );
};

export default BrandSettings;
